(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-static/map-static.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-static/map-static.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const getStaticMapHandler = svs.tur.lyckoplatsen.map.getStaticMapHandler;
const mapDefaults = svs.tur.lyckoplatsen.map.mapDefaults;

const MapStatic = _ref => {
  let lat = _ref.lat,
    lng = _ref.lng,
    locationName = _ref.locationName,
    charity = _ref.charity,
    _ref$useSmallIcon = _ref.useSmallIcon,
    useSmallIcon = _ref$useSmallIcon === void 0 ? false : _ref$useSmallIcon,
    errorCallback = _ref.errorCallback;
  const mapHandlerStatic = useMemo(() => getStaticMapHandler(), []);
  const staticId = _.uniqueId('map-static-');
  useEffect(() => {
    const coord = {
      lat: String(lat).replace(',', '.'),
      lng: String(lng).replace(',', '.')
    };
    const mapOptions = {
      nodeId: staticId,
      center: [coord.lat, coord.lng],
      dragging: false,
      zoom: mapDefaults.maxZoom,
      zoomControl: false,
      scrollWheelZoom: false,
      keyboard: false,
      doubleClickZoom: false,
      boxZoom: false,
      touchZoom: false,
      tap: false
    };
    mapHandlerStatic.createMap({
      mapOptions,
      coord,
      charity,
      locationName,
      useSmallIcon,
      errorCallback: () => {
        errorCallback === null || errorCallback === void 0 || errorCallback();
      }
    });
    return () => mapHandlerStatic.removeMap();
  }, [lat, lng, mapHandlerStatic, staticId, charity, locationName, useSmallIcon, errorCallback]);
  return React.createElement("div", {
    className: "lyckoplatsen-map-static",
    id: staticId,
    style: {
      height: '100%',
      width: '100%',
      zIndex: 0
    }
  });
};
Object.assign(svs.tur.lyckoplatsen.map, {
  MapStatic
});

 })(window);